import { ReactElement, ReactNode, useState, memo } from 'react';
import { Grid, Button, Typography, CSSObject } from '@mui/material';
import { IComponentCss } from '@tap/mui-ui';
import ExpandMoreOutlinedIcon from '@mui/icons-material/ExpandMoreOutlined';
import ChevronRightOutlinedIcon from '@mui/icons-material/ChevronRightOutlined';

/**
 *   Блок с информацией
 */

type IBlockWrap = {
    /** Заголовок блока */
    title: string,

    /** Контент блока */
    children?: ReactNode | ReactElement<any, any> | Element,

    /** Количество колонок для маленького разрешения (по умолчанию 12) */
    xs?: number,

    /** Количество колонок для среднего разрешения (по умолчанию 12) */
    sm?: number,

    /** Количество колонок для большого разрешения (по умолчанию 12) */
    md?: number,

    /** Дополнительные стили для блока */
    blockWrapStyle?: CSSObject,
}


const css: IComponentCss = {
    blockWrap: { marginBottom: '20px' },
    titleButton: {
        color: '#212121',
        height: '28px',
        lineHeight: 1,
        paddingLeft: 0,
        '&:hover': {
            background: 'none',
        },
    },
    titleIcon: {
        marginBottom: '1px',
    },
    titleTypography: {
        textTransform: 'none',
        fontWeight: 700,
        color: '#212121',
    },
    contentWrap: {
        width: '100%',
        paddingLeft: '24px',
        paddingTop: '4px',
    },
};

export const InfoBlock = memo(({
    title,
    children,
    xs = 12,
    sm = 12,
    md = 12,
    blockWrapStyle = {},
}: IBlockWrap): ReactElement => {

    const [isOpen, setIsOpen] = useState<boolean>(true);

    const handleChangeState = (): void => {
        setIsOpen(prev => !prev);
    };

    return (
        <Grid
            item
            container
            xs={xs}
            sm={sm}
            md={md}
            sx={{ ...css.blockWrap, ...blockWrapStyle }}
        >
            <Button
                size='small'
                variant='text'
                color='primary'
                onClick={handleChangeState}
                sx={css.titleButton}
                startIcon={
                    isOpen
                        ? <ExpandMoreOutlinedIcon sx={css.titleIcon} />
                        : <ChevronRightOutlinedIcon sx={css.titleIcon} />
                }
            >
                <Typography sx={css.titleTypography}>
                    {title}
                </Typography>
            </Button>

            {isOpen &&
                <Grid container sx={css.contentWrap}>
                    <>{children}</>
                </Grid>
            }
        </Grid>
    );
});